import axios from 'axios';
const httpClient = axios.create();
export class BaseAPI {
    url;
    retry;
    constructor(url, retry = { attempts: 0, delay: 1000 }) {
        this.url = url;
        this.retry = retry;
    }
    sleep = (delay) => new Promise(resolve => {
        setTimeout(resolve, delay);
    });
    async request(method, path, params = null, axiosRequestConfig = {}, retryParams) {
        const retry = retryParams ?? this.retry;
        let options = {
            ...axiosRequestConfig,
            method,
            url: this.getUrl(path)
        };
        if (params) {
            if (method?.toLowerCase() === 'get') {
                options.params = params;
            }
            else {
                options.data = params;
            }
        }
        let attempts = 0;
        while (true) {
            try {
                const axiosResponse = await httpClient.request(options);
                const { ok, data, error } = this.parseResponse(axiosResponse);
                return !ok || error ? Promise.reject({ message: error, data }) : data;
            }
            catch (error) {
                console.error(`[API] HTTP request failed: ${error.message || ''}`, error);
                if (retry.attempts <= attempts)
                    throw error;
                attempts++;
            }
            await this.sleep(retry.delay);
        }
    }
    getUrl(path) {
        return `${this.url}${path}`;
    }
    parseResponse(axiosResponse) {
        const response = axiosResponse.data;
        if (typeof response.ok === 'boolean') {
            return response;
        }
        return { ok: true, data: response, error: '' };
    }
}
//# sourceMappingURL=api.js.map